import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#lwxwrgaqx__clip0_13953_91164)",
        children: [_jsx("path", {
          d: "M12.0005 -0.000967026C18.6282 -0.000967026 24.001 5.37183 24.001 11.9995C24.001 18.6272 18.6282 24 12.0005 24C5.3728 24 0 18.6272 0 11.9995C0 5.37183 5.3728 -0.000967026 12.0005 -0.000967026Z",
          fill: "#616161"
        }), _jsx("path", {
          d: "M12.0005 4.36311C7.78243 4.36311 4.36408 7.78146 4.36408 11.9995C4.36408 16.2176 7.78243 19.6359 12.0005 19.6359C14.1085 19.6359 16.0174 18.7811 17.4002 17.3993L20.4859 20.485C18.314 22.6568 15.3134 24 12.0005 24C5.37266 24 0 18.6273 0 11.9995C0 5.37169 5.37266 -0.000967026 12.0005 -0.000967026C15.3144 -0.000967026 18.314 1.3422 20.4869 3.51311L17.4012 6.59882C16.0174 5.21794 14.1085 4.36311 12.0005 4.36311Z",
          fill: "#9E9E9E"
        }), _jsx("path", {
          d: "M19.637 11.9977H15.8183C15.8183 14.1058 14.1086 15.8164 11.9996 15.8164C9.89058 15.8164 8.18188 14.1067 8.18188 11.9977C8.18188 10.9708 8.58803 10.0395 9.24849 9.352L9.24559 9.3491L13.9733 4.62143L13.9742 4.62047C17.2349 5.49077 19.637 8.46333 19.637 11.9977Z",
          fill: "#424242"
        }), _jsx("path", {
          d: "M24 12H19.6359C19.6359 8.46561 17.2329 5.49305 13.9741 4.62275L17.3441 1.25275C21.2895 3.21866 24 7.29264 24 12Z",
          fill: "#616161"
        }), _jsx("path", {
          d: "M12.0005 0.134581C5.39587 0.134581 0.03868 5.47049 0.000967005 12.0664C0.000967005 12.0432 0 12.021 0 11.9977C0 5.36992 5.37266 -0.00273323 12.0005 -0.00273323C18.6283 -0.00273323 24.001 5.36992 24.001 11.9977C24.001 12.021 24 12.0432 24 12.0664C23.9623 5.47049 18.6041 0.134581 12.0005 0.134581Z",
          fill: "#212121",
          fillOpacity: "0.1"
        }), _jsx("path", {
          d: "M13.9751 4.62275L14.0815 4.51638C17.2861 5.42149 19.6369 8.36698 19.6369 11.8637V12C19.6369 8.46561 17.2339 5.49305 13.9751 4.62275Z",
          fill: "white",
          fillOpacity: "0.05"
        }), _jsx("path", {
          d: "M21.8189 13.0898H12C11.3975 13.0898 10.9092 12.6015 10.9092 11.9991C10.9092 11.3966 11.3975 10.9083 12 10.9083H21.8179C22.4203 10.9083 22.9087 11.3966 22.9087 11.9991C22.9096 12.6015 22.4213 13.0898 21.8189 13.0898Z",
          fill: "#9E9E9E"
        }), _jsx("path", {
          opacity: "0.5",
          d: "M21.8189 13.0898H12C11.3975 13.0898 10.9092 12.6015 10.9092 11.9991C10.9092 11.3966 11.3975 10.9083 12 10.9083H21.8179C22.4203 10.9083 22.9087 11.3966 22.9087 11.9991C22.9096 12.6015 22.4213 13.0898 21.8189 13.0898Z",
          fill: "#BDBDBD"
        }), _jsx("path", {
          d: "M2.18161 11.1802C2.63342 11.1802 2.99969 11.5465 2.99969 11.9983C2.99969 12.4501 2.63342 12.8164 2.18161 12.8164C1.72979 12.8164 1.36353 12.4501 1.36353 11.9983C1.36353 11.5465 1.72979 11.1802 2.18161 11.1802Z",
          fill: "#BDBDBD"
        }), _jsx("path", {
          d: "M12.0005 21.0006C12.4523 21.0006 12.8185 21.3668 12.8185 21.8186C12.8185 22.2705 12.4523 22.6367 12.0005 22.6367C11.5486 22.6367 11.1824 22.2705 11.1824 21.8186C11.1824 21.3668 11.5486 21.0006 12.0005 21.0006Z",
          fill: "#BDBDBD"
        }), _jsx("path", {
          d: "M12.0005 1.36384C12.4523 1.36384 12.8185 1.7301 12.8185 2.18192C12.8185 2.63373 12.4523 3 12.0005 3C11.5486 3 11.1824 2.63373 11.1824 2.18192C11.1824 1.7301 11.5486 1.36384 12.0005 1.36384Z",
          fill: "#BDBDBD"
        }), _jsx("path", {
          d: "M5.04587 18.1256C5.49768 18.1256 5.86395 18.4918 5.86395 18.9436C5.86395 19.3955 5.49768 19.7617 5.04587 19.7617C4.59405 19.7617 4.22778 19.3955 4.22778 18.9436C4.22778 18.4918 4.59405 18.1256 5.04587 18.1256Z",
          fill: "#BDBDBD"
        }), _jsx("path", {
          d: "M5.04587 4.22711C5.49768 4.22711 5.86395 4.59338 5.86395 5.0452C5.86395 5.49701 5.49768 5.86328 5.04587 5.86328C4.59405 5.86328 4.22778 5.49701 4.22778 5.0452C4.22778 4.59338 4.59405 4.22711 5.04587 4.22711Z",
          fill: "#BDBDBD"
        }), _jsx("path", {
          d: "M18.955 4.22711C19.4069 4.22711 19.7731 4.59338 19.7731 5.0452C19.7731 5.49701 19.4069 5.86328 18.955 5.86328C18.5032 5.86328 18.137 5.49701 18.137 5.0452C18.137 4.59338 18.5032 4.22711 18.955 4.22711Z",
          fill: "#757575"
        }), _jsx("path", {
          d: "M12.0004 12.9535H21.8184C22.3976 12.9535 22.8715 12.5009 22.9053 11.9304C22.9063 11.9536 22.9092 11.9759 22.9092 11.9991C22.9092 12.6015 22.4209 13.0898 21.8184 13.0898H12.0004C11.398 13.0898 10.9097 12.6015 10.9097 11.9991C10.9097 11.9759 10.9106 11.9536 10.9135 11.9304C10.9474 12.5009 11.4202 12.9535 12.0004 12.9535Z",
          fill: "white",
          fillOpacity: "0.2"
        }), _jsx("path", {
          d: "M22.9053 11.9336C22.8695 11.364 22.3967 10.9105 21.8184 10.9105H12.0004C11.4212 10.9105 10.9474 11.3631 10.9135 11.9336C10.9106 11.9104 10.9097 11.8881 10.9097 11.8659C10.9097 11.2635 11.398 10.7751 12.0004 10.7751H21.8184C22.4209 10.7751 22.9092 11.2635 22.9092 11.8659C22.9092 11.8881 22.9082 11.9104 22.9053 11.9336Z",
          fill: "#212121",
          fillOpacity: "0.2"
        }), _jsx("path", {
          d: "M12.0004 19.498C14.1085 19.498 16.0173 18.6432 17.4001 17.2614L20.5526 20.4157C20.5294 20.4389 20.5071 20.4621 20.4849 20.4844L17.4001 17.3987C16.0173 18.7805 14.1085 19.6353 12.0004 19.6353C7.78236 19.6353 4.36401 16.217 4.36401 11.9989C4.36401 11.9757 4.36498 11.9535 4.36498 11.9303C4.40173 16.1164 7.80557 19.498 12.0004 19.498Z",
          fill: "#212121",
          fillOpacity: "0.1"
        }), _jsx("path", {
          d: "M12.0005 -0.000967026C18.6282 -0.000967026 24.001 5.37183 24.001 11.9995C24.001 18.6272 18.6282 24 12.0005 24C5.3728 24 0 18.6272 0 11.9995C0 5.37183 5.3728 -0.000967026 12.0005 -0.000967026Z",
          fill: "url(#gww4k4v2u__paint0_radial_13953_91164)"
        })]
      }), _jsxs("defs", {
        children: [_jsxs("radialGradient", {
          id: "gww4k4v2u__paint0_radial_13953_91164",
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(3.51922 20.5081) scale(23.9595)",
          children: [_jsx("stop", {
            stopColor: "white",
            stopOpacity: "0.1"
          }), _jsx("stop", {
            offset: "1",
            stopColor: "white",
            stopOpacity: "0"
          })]
        }), _jsx("clipPath", {
          id: "lwxwrgaqx__clip0_13953_91164",
          children: _jsx("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "matrix(1 0 0 -1 0 24)"
          })
        })]
      })]
    }))
  });
};
export default Component;
